export enum CommandActivity {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum ModuleTableEnum {
  TOUR_TRASH = 'TourTrashEntity',
  PERK = 'PerkEntity',
  HOME_WIDGETS = 'HomeWidgetEntity',
  ACCESS_CODE = 'AccessCodeEntity',
  TTB_FRAUD = 'TTBFraudEntity',
  TTB = 'TTBEntity',
  USER_BLACKLIST = 'UserBlackListEntity',
  USER = 'UserEntity',
  PRODUCT_ORDER = 'ProductOrderEntity',
  PAID_FEATURE = 'Paid Features',
  SHOW_FEATURES = 'Show/Hide Features',
  LAUNCH_FEATURES = 'Launch Features',
  LOYALTY_ACTION = 'LoyaltyActionEntity',
}
export interface ActivityLogInterface {
  id: string;
  columnChanged: string;
  command: CommandActivity;
  email?: string;
  fullName?: string;
  itemId: string;
  modifiedAt?: string;
  modifiedBy?: string;
  module: ModuleTableEnum;
  prevColumnValue?: { [key: string]: string };
  nextColumnValue?: { [key: string]: string };
}
